<div class="w-full flex flex-col flex-1 min-h-0">
<div class="flex flex-col flex-1 min-h-0 overflow-hidden">

  <!-- Primera carga: tabla Skeleton -->
  @if (loading() && !initialLoadDone()) {
    <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
      <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <p-skeleton width="8rem" height="1.5rem" class="mb-2" />
            <p-skeleton width="14rem" height="0.875rem" />
          </div>
          <div class="w-full sm:w-auto flex justify-end">
            <p-skeleton width="10rem" height="2.5rem" />
          </div>
        </div>
      </div>
      <div class="flex-1 min-h-0 overflow-auto">
        <table class="w-full border-collapse">
          <thead class="bg-slate-50 border-b border-slate-200">
            <tr>
              <th class="px-2 py-2 text-left text-xs font-semibold text-slate-700 uppercase">Producto</th>
              <th class="px-2 py-2 text-left text-xs font-semibold text-slate-700 uppercase">SKU</th>
              <th class="px-2 py-2 text-left text-xs font-semibold text-slate-700 uppercase">Precio</th>
              <th class="px-2 py-2 text-left text-xs font-semibold text-slate-700 uppercase">Moneda</th>
              <th class="px-2 py-2 text-left text-xs font-semibold text-slate-700 uppercase">Unidad</th>
              <th class="px-2 py-2 text-left text-xs font-semibold text-slate-700 uppercase">Código fiscal</th>
              <th class="px-2 py-2 text-left text-xs font-semibold text-slate-700 uppercase">Estado</th>
              <th class="px-2 py-2 text-right text-xs font-semibold text-slate-700 uppercase">Acciones</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-slate-100">
            @for (row of skeletonRows; track row) {
              <tr>
                <td class="px-2 py-2"><div class="flex items-center gap-2"><p-skeleton shape="circle" size="2.5rem" /><p-skeleton width="7rem" height="0.875rem" /><p-skeleton width="5rem" height="0.75rem" class="mt-1" /></div></td>
                <td class="px-2 py-2"><p-skeleton width="4rem" height="0.875rem" /></td>
                <td class="px-2 py-2"><p-skeleton width="4rem" height="0.875rem" /></td>
                <td class="px-2 py-2"><p-skeleton width="3rem" height="0.875rem" /></td>
                <td class="px-2 py-2"><p-skeleton width="4rem" height="0.875rem" /></td>
                <td class="px-2 py-2"><p-skeleton width="5rem" height="0.875rem" /></td>
                <td class="px-2 py-2"><p-skeleton width="4rem" height="1.25rem" /></td>
                <td class="px-2 py-2 text-right"><p-skeleton width="4rem" height="2rem" /></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="bg-slate-50 px-6 py-4 border-t border-slate-200 flex justify-end shrink-0">
        <p-skeleton width="12rem" height="2rem" />
      </div>
    </div>
  }

  <!-- Error State -->
  @if (error() && !loading()) {
    <div class="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
      <div class="flex items-center">
        <mat-icon class="text-red-600 mr-2">error</mat-icon>
        <p class="text-red-800">{{ error() }}</p>
      </div>
      <button
        (click)="loadProducts()"
        class="mt-3 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">
        Reintentar
      </button>
    </div>
  }

  <!-- Tabla PrimeNG: siempre visible tras primera carga (con filtros) para poder seguir filtrando aunque no haya resultados -->
  @if (initialLoadDone() && !error()) {
    <div class="flex-1 min-h-0 flex flex-col">
      <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <div class="rounded-t-xl px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
          <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <h2 class="text-lg font-semibold text-slate-900 flex items-center gap-2">
                <span class="flex h-9 w-9 items-center justify-center rounded-lg bg-sky-100 text-sky-600">
                  <i class="pi pi-box"></i>
                </span>
                Productos
              </h2>
              <p class="text-sm text-slate-500 mt-1">Catálogo de productos registrados.</p>
            </div>
            <div class="w-full sm:w-auto flex flex-wrap items-center justify-end gap-2">
              <a routerLink="/products/nuevo" class="inline-block" appDisableUnless="PRODUCT_WRITE">
                <p-button label="Nuevo producto" icon="pi pi-plus" severity="primary" size="small" appDisableUnless="PRODUCT_WRITE" />
              </a>
            </div>
          </div>
        </div>

        <div [formGroup]="filtersForm" class="border-b border-slate-200 bg-slate-50 shrink-0 px-3 py-2">
          <div class="grid grid-cols-2 sm:flex sm:flex-wrap sm:items-end gap-2">
            <div class="min-w-0 col-span-2 sm:flex-1 sm:min-w-40">
              <p-floatlabel class="w-full" variant="on">
                <p-iconfield class="w-full">
                  <p-inputicon class="pi pi-search text-sm" />
                  <input pInputText id="filterProductsQ" formControlName="q" class="w-full p-inputtext-sm" autocomplete="off" />
                  @if (filtersForm.controls.q.value) {
                    <p-inputicon class="pi pi-times text-sm cursor-pointer" (click)="filtersForm.controls.q.setValue('', { emitEvent: false }); applyFilters()" />
                  }
                </p-iconfield>
                <label for="filterProductsQ">Nombre, SKU o ID externo</label>
              </p-floatlabel>
            </div>
            <p-floatlabel class="w-full min-w-0 sm:w-32" variant="on">
              <p-select
                formControlName="state"
                inputId="filterProductsState"
                [options]="stateFilterOptions"
                optionLabel="label"
                optionValue="value"
                size="small"
                [showClear]="true"
                class="w-full" />
              <label for="filterProductsState">Estado</label>
            </p-floatlabel>
            @if (hasActiveFilters()) {
              <div class="flex items-end">
                <p-button
                  icon="pi pi-times"
                  [rounded]="true"
                  [text]="true"
                  size="small"
                  severity="secondary"
                  type="button"
                  (onClick)="clearFilters()"
                  ariaLabel="Limpiar filtros" />
              </div>
            }
          </div>
        </div>

        <div class="flex-1 min-h-0 overflow-hidden rounded-b-xl">
          <p-table
            #dt2
            [value]="products()"
            dataKey="id"
            [lazy]="true"
            [scrollable]="true"
            scrollHeight="flex"
            [totalRecords]="totalItems()"
            [first]="currentPage() * pageSize()"
            [rows]="pageSize()"
            [rowsPerPageOptions]="pageSizeOptions"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} productos"
            [loading]="loading()"
            [paginator]="true"
            sortMode="single"
            [sortField]="sortField()"
            [sortOrder]="sortOrder()"
            (onLazyLoad)="onLazyLoad($event)"
            [globalFilterFields]="['name', 'sku', 'state']"
            [tableStyle]="{ width: '100%' }"
            styleClass="products-primeng-table p-datatable-striped p-datatable-sm"
            [rowHover]="true"
            paginatorStyleClass="!border-0 !bg-transparent !pt-4 !flex !justify-end"
          >
            <ng-template pTemplate="header">
              <tr>
                <th class="!px-2 min-w-[150px] max-w-[250px]" pSortableColumn="name">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>Producto</span>
                    @if (sortField() === 'name') {
                      <p-sortIcon field="name" />
                    }
                  </span>
                </th>
                <th class="!px-2 !whitespace-nowrap" pSortableColumn="sku">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>SKU</span>
                    @if (sortField() === 'sku') {
                      <p-sortIcon field="sku" />
                    }
                  </span>
                </th>
                <th class="!px-2 !whitespace-nowrap" pSortableColumn="externalId">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>ID externo</span>
                    @if (sortField() === 'externalId') {
                      <p-sortIcon field="externalId" />
                    }
                  </span>
                </th>
                <th class="!px-2 !whitespace-nowrap !text-right" pSortableColumn="unitPrice">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>Precio</span>
                    @if (sortField() === 'unitPrice') {
                      <p-sortIcon field="unitPrice" />
                    }
                  </span>
                </th>
                <th class="!px-2 !whitespace-nowrap">Moneda</th>
                <th class="!px-2">Unidad</th>
                <th class="!px-2 !whitespace-nowrap">Código fiscal</th>
                <th class="!px-2 !whitespace-nowrap !text-center">Impuestos</th>
                <th class="!px-2 !whitespace-nowrap" pSortableColumn="state">
                  <span class="inline-flex items-center justify-between gap-1.5 w-full">
                    <span>Estado</span>
                    @if (sortField() === 'state') {
                      <p-sortIcon field="state" />
                    }
                  </span>
                </th>
                <th class="!px-2 !whitespace-nowrap !text-right">Acciones</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product>
              <tr class="cursor-pointer hover:!bg-sky-50/50 transition-colors !border-slate-100" (click)="openProductDetails(product)">
                <td class="!px-2 !py-2 !border-slate-100 min-w-[150px] max-w-[250px] overflow-hidden">
                  <div class="flex items-center gap-2 min-w-0">
                    <div class="shrink-0 h-8 w-8 rounded-full bg-sky-100 flex items-center justify-center text-sky-600 [&>i]:text-sm">
                      <i class="pi pi-box"></i>
                    </div>
                    <div class="min-w-0 flex-1 overflow-hidden">
                      <div class="text-sm font-medium text-slate-900 truncate" [title]="product.name">{{ product.name }}</div>
                      <div class="text-xs text-slate-500 truncate" [title]="product.description || ''">{{ product.description || '-' }}</div>
                    </div>
                  </div>
                </td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-700 !whitespace-nowrap">{{ product.sku || '-' }}</td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-900 !whitespace-nowrap">{{ product.externalId || '-' }}</td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-900 !whitespace-nowrap !text-right">{{ (product.unitPrice ?? 0) | number:'1.2-4':'en-US' }}</td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-600 !whitespace-nowrap">{{ product.currency?.code || '-' }}</td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-600">{{ product.measureUnitName || product.measureUnitCode || '-' }}</td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-600 !whitespace-nowrap">{{ product.taxCodeTaxCode || '-' }}</td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-600 !text-center">{{ product.taxes?.length ?? 0 }}</td>
                <td class="!px-2 !py-2 !border-slate-100 !whitespace-nowrap">
                  <p-tag [value]="product.state === 'ACTIVE' ? 'Activo' : 'Inactivo'" [severity]="getStateSeverity(product.state) ?? undefined" class="!text-xs" />
                </td>
                <td class="!px-2 !py-2 !border-slate-100 !text-right !whitespace-nowrap" (click)="$event.stopPropagation()" pFrozenColumn>
                  <span class="inline-flex items-center gap-0.5">
                    <p-button icon="pi pi-pen-to-square" [rounded]="true" [text]="true" severity="secondary" styleClass="hover:!bg-sky-100" (onClick)="editProduct(product, $event)" appDisableUnless="PRODUCT_WRITE" />
                    <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger" (onClick)="openDeleteModal(product, $event)" appDisableUnless="PRODUCT_DELETE" />
                  </span>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="10" class="!px-2 !py-12 !text-center !text-slate-500 !border-slate-100">
                  No se encontraron productos con los filtros aplicados.
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  }

</div>

  @if (deleteModalOpen()) {
    <div class="fixed inset-0 z-50 flex items-center justify-center">
      <div class="absolute inset-0 bg-black transition-opacity duration-300 ease-out"
        [class.bg-opacity-50]="deleteModalShown()" [class.bg-opacity-0]="!deleteModalShown()"
        (click)="closeDeleteModal()"></div>
      <div class="relative bg-white rounded-xl shadow-xl w-full max-w-md p-6 z-10 transform transition-all duration-300 ease-out"
        [class.opacity-100]="deleteModalShown()" [class.opacity-0]="!deleteModalShown()"
        [class.scale-100]="deleteModalShown()" [class.scale-95]="!deleteModalShown()">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-semibold text-slate-900">Confirmar eliminación</h3>
          <button type="button" class="text-slate-500 hover:text-slate-700" (click)="closeDeleteModal()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <p class="text-sm text-slate-600 mb-6">
          ¿Está seguro de eliminar el producto "{{ productToDelete()?.name }}"? Esta acción no se puede deshacer.
        </p>
        <div class="flex justify-end gap-3">
          <button type="button" mat-stroked-button (click)="closeDeleteModal()">Cancelar</button>
          <button type="button" mat-raised-button color="warn" [disabled]="deleteLoading()"
            (click)="confirmDeleteProduct()">
            {{ deleteLoading() ? 'Eliminando...' : 'Eliminar' }}
          </button>
        </div>
      </div>
    </div>
  }

  <p-drawer
    [visible]="isDetailsOpen()"
    position="right"
    (visibleChange)="onDrawerVisibleChange($event)"
    styleClass="product-details-drawer !w-[800px]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <div class="flex items-center justify-between w-full gap-3">
        <h3 class="text-lg font-semibold text-slate-900">Detalles del producto</h3>
        @if (selectedProduct() && !detailsLoading()) {
          <button
            type="button"
            class="inline-flex items-center gap-2 text-sm font-semibold bg-blue-600 text-white px-3 py-2 rounded-lg shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 shrink-0"
            (click)="editFromModal()">
            <i class="pi pi-pencil text-sm"></i>
            Editar
          </button>
        }
      </div>
    </ng-template>
    @if (detailsLoading()) {
      <div class="flex flex-col items-center justify-center py-12 gap-4">
        <i class="pi pi-spin pi-spinner text-4xl text-sky-500"></i>
        <p class="text-sm text-slate-600">Cargando producto...</p>
      </div>
    } @else if (selectedProduct()) {
      <app-product-read [product]="selectedProduct()!" />
    }
  </p-drawer>
</div>
